// Global timeframe helper: persisted in localStorage and broadcast via event

const STORAGE_KEY = 'tp_timeframe';

function toDateKey(d) {
  const dt = new Date(d);
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const day = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function getCurrentFYRange() {
  const today = new Date();
  const fyStartYear = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1; // April=3
  const start = new Date(fyStartYear, 3, 1);
  const end = new Date(fyStartYear + 1, 2, 31);
  return { from: toDateKey(start), to: toDateKey(end) };
}

export function getPreviousFYRange() {
  const curr = getCurrentFYRange();
  const from = new Date(curr.from);
  const prevStart = new Date(from.getFullYear() - 1, 3, 1);
  const prevEnd = new Date(from.getFullYear(), 2, 31);
  return { from: toDateKey(prevStart), to: toDateKey(prevEnd) };
}

export function getTimeframe() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  const def = { mode: 'fy_current', ...getCurrentFYRange() };
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(def)); } catch {}
  return def;
}

export function setTimeframe(tf) {
  const safe = { ...tf };
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(safe)); } catch {}
  try {
    const evt = new CustomEvent('TP_TIMEFRAME_CHANGE', { detail: safe });
    window.dispatchEvent(evt);
  } catch {}
}

export function toIsoRange(tf) {
  // Convert YYYY-MM-DD to ISO string bounds
  try {
    const fromD = new Date(tf.from);
    const toD = new Date(tf.to);
    toD.setHours(23, 59, 59, 999);
    return { from: fromD.toISOString(), to: toD.toISOString() };
  } catch {
    return { from: undefined, to: undefined };
  }
}


